import { createSlice } from "@reduxjs/toolkit";

export const SelectedClientSlice = createSlice({
  name: "selectedClient",
  initialState: {
    value: "",
  },
  reducers: {
    updateClient: (state, action) => {
      state.value = action.payload;
    },
    removeClient: (state) => {
      state.value = "";
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateClient, removeClient } = SelectedClientSlice.actions;

export const selectClientValue = (state) => state.selectedClient.value;

export default SelectedClientSlice.reducer;
